import { useSelector } from 'react-redux'

export const useApplicationList = () => {
  const applicationList = useSelector((state) => state.permissions.roleApplication)
  return applicationList?.reduce((acc, item) => {
    acc[item.name] = item.description
    return acc
  }, {})
}
